import axios from 'axios';

const SummarizeMetaDescription = {
  create(node) {
    this.submitButton = node.querySelector('button[type="button"]');

    this.submitButton.addEventListener('click', () => {
      this.submitButton.setAttribute('disabled', 'disabled');

      this.url = node.getAttribute('data-url');

      this.sendRequest();
    });
  },

  sendRequest() {
    const element = document.querySelector('#summarize-meta-description-message');

    axios
      .post(this.url)
      .then((response) => {
        element.innerHTML = response.data.message;
      });
  },
};

export default SummarizeMetaDescription;
